import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createHashHistory } from 'history';
import entityComposition from '../common/classes/entityComposition';
const hashHistory = createHashHistory();
const Logout = props => {
  const loginActions = props.loginActions;
  useEffect(() => {
    // Navigate to home page
    hashHistory.push('/');

    // Logout with auto-save of pending changes (sets logout message automatically)
    loginActions.logoutUserWithSave();
  }, [loginActions]);
  return /*#__PURE__*/React.createElement("div", null);
};
Logout.propTypes = {
  loginActions: PropTypes.shape({
    logoutUserWithSave: PropTypes.func
  }).isRequired
};
export { Logout as TestLogout };
export default entityComposition(Logout, [], {}, ['login']);